import React from "react";

import Typewriter from "typewriter-effect";

import Button from "../../components/Button";
import SocialLinks from "../../components/SocialLinks";

const Home = () => {
  const strings = [
    "MERN Stack Developer",
    "Fullstack Developer",
    "Junior Web Developer",
    "Front-End Developer",
    "Backend Developer",
  ];
  return (
    <div className="min-h-screen w-full flex items-center justify-center ">
      <div
        className=" flex items-center justify-center"
        data-aos="zoom-in"
        data-aos-duration="1500"
      >
        <div className="content text-center w-4/5 mx-auto text-white">
          <h1 className="text-5xl font-bold  my-5">
            Hi, I'm <span className="text-primary">Mahamodul Hasan Moon</span>
          </h1>
          <h3 className="text-3xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary my-5">
            <Typewriter
              options={{
                strings: strings,
                autoStart: true,
                loop: true,
                pauseFor: 4000,
                changeDelay: 100,
                cursor: "_",
              }}
            />
          </h3>
          <p className="text-lg leading-7 my-5 text-secondaryWhite">
          As a Full Stack Developer, my goal is to build intuitive and responsive web applications using my skills in HTML, CSS, JavaScript, MongoDB, and Node.js. I am a self-learner and dedicated hard worker, and I am currently exploring the React framework to expand my expertise in this area. I aim to create high-quality web applications that meet the needs of clients.
          </p>

          {/* social links */}
          <div className="flex justify-center">
            <SocialLinks className="justify-center" />
          </div>

          {/* social link  end*/}

          {/* rsume */}

          <a
            rel="noreferrer"
            target="_blank"
            href="https://drive.google.com/file/d/1LcxWbwAVdmgeiDzz1SwmPxKgqyhUbbWM/view?usp=share_link"
          >
            {" "}
            <Button>Download Resume</Button>{" "}
          </a>

          <div className="quote z-50 py-5">
            <pre className="bg-[#191d2b]  text-lg py-2 rounded-[6px] text-white mt-8">
              “First, solve the problem. <br /> Then, write the code.”
            </pre>
          </div>
          {/* wave */}

        </div>
      </div>

    </div>
  );
};

export default Home;
